/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import type { MentionActe } from '@/types';

import rtfToText from '../rtfToText';

/**
 * Le champ `texte` peut être stocké en RTF, et `rtfToText` — utilisé pour
 * l'afficher lisiblement — est une conversion à sens unique. On ne renvoie donc
 * la valeur du formulaire que si l'utilisateur l'a effectivement modifiée ;
 * sinon on repart du texte d'origine, sans quoi corriger un simple numéro
 * écraserait silencieusement le RTF par sa version aplatie.
 */
const resolveTexte = (texteOrigine?: string, texteSaisi?: string) =>
  texteSaisi === rtfToText(texteOrigine)
    ? (texteOrigine ?? '')
    : (texteSaisi ?? '');

/**
 * Construit le corps de `PUT /mentions/{identifiant}`.
 *
 * Cet endpoint est générique à tous les types d'acte, contrairement au PUT du
 * dossier de numérisation : il permet donc de modifier une mention depuis la
 * fiche de reconnaissance, pour laquelle
 * `PUT /numerisation-actes/reconnaissance/{id}` n'existe pas.
 *
 * ⚠️ Le corps ne contient **ni identifiant racine** (il est dans l'URL) **ni
 * clé de rattachement à l'acte** : `MentionController::update()` déclare les
 * quatre `identifiantActe*` en `prohibited` et répondrait 422. Le rattachement
 * d'une mention existante ne change de toute façon jamais.
 *
 * @param mention Mention telle que lue dans la liste de la fiche.
 * @param data État du formulaire de la modale.
 */
const buildMentionPutPayload = (
  mention?: Partial<MentionActe> | null,
  data?: Record<string, any>,
) => ({
  numero: Number(data?.numero),
  dateApposition: data?.dateApposition,
  titre: data?.titre,
  texte: resolveTexte(mention?.texte, data?.texte),
  ...(!_.isNil(data?.identifiantCodeAnts) &&
    data?.identifiantCodeAnts !== '' && {
      identifiantCodeAnts: Number(data?.identifiantCodeAnts),
    }),
});

export default buildMentionPutPayload;
